import React, { useContext } from 'react';
import { Grid, Avatar, Typography } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import PhoneIcon from '@material-ui/icons/Phone';
import { I18nContext } from 'translations';

// Own layout instead of reusing components/Cards/DriverCard — that card is shared with the
// classic booking/tracking views and its row layout (avatar/name/plate/phone inline) doesn't
// match this redesign's card. The route payload already carries `driver` and `served_vehicle`
// serialized by Api::Web::{Driver,Vehicle}Serializer, and the backend strips `phone` on a
// public visibility level — the front only renders what arrives.
const initials = (name) => (name || '')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((part) => part[0])
  .join('')
  .toUpperCase();

export default function RouteDriver({ route }) {
  const { translate } = useContext(I18nContext);
  const driver = route?.driver;
  if (!driver) return null;

  const phone = driver.phone
    ? `${driver.country_code || ''}${driver.phone}`
    : null;

  return (
    <Grid container alignItems="center" justify="space-between" wrap="nowrap" data-testid="route-driver">
      <Grid item>
        <Grid container alignItems="center" wrap="nowrap" spacing={2}>
          <Grid item>
            <Avatar
              src={driver.photo_url || undefined}
              style={{ backgroundColor: '#EFE3FB', color: '#7825bd', fontWeight: 700, width: 48, height: 48 }}
            >
              {!driver.photo_url && initials(driver.name)}
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="caption" color="textSecondary" style={{ textTransform: 'uppercase', letterSpacing: 0.4 }}>
              {translate('app.deliveryRoute.driver')}
            </Typography>
            <Typography variant="subtitle1" color="textPrimary" style={{ fontWeight: 700, lineHeight: 1.2 }}>
              {driver.name}
            </Typography>
            {route.served_vehicle?.plates && (
              <Typography variant="body2" color="textSecondary">
                {translate('tracking.plate')} <b>{route.served_vehicle.plates}</b>
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ textAlign: 'right' }}>
        {driver.rating_as_driver && (
          <Typography component="div" variant="body2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 4, fontWeight: 700 }}>
            <StarIcon style={{ color: '#F5A623', fontSize: 18 }} />
            {driver.rating_as_driver}
          </Typography>
        )}
        {phone && (
          <Typography component="div" variant="body2" style={{ marginTop: 4 }}>
            <a
              href={`tel:+${phone}`}
              style={{ color: '#7825bd', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
            >
              <PhoneIcon style={{ fontSize: 16 }} />
              {phone}
            </a>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}
